import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/useAuth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResendVerifyEmail from './pages/ResendVerifyEmail'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Landing from './pages/Landing'
import Dashboard from './pages/Dashboard'
import Upload from './pages/Upload'
import TrackDetail from './pages/TrackDetail'
import JobQueue from './pages/JobQueue'
import History from './pages/History'
import Compare from './pages/Compare'
import Settings from './pages/Settings'
import FAQ from './pages/FAQ'
import Impressum from './pages/Impressum'
import Datenschutz from './pages/Datenschutz'
import AGB from './pages/AGB'
import Nutzungsbedingungen from './pages/Nutzungsbedingungen'
import Anleitung from './pages/Anleitung'
import Admin from './pages/Admin'
import BuyCredits from './pages/BuyCredits'

function PrivateRoute({ children }) {
  const { token, loading } = useAuth()
  if (loading) return <div className="app-loading">Laden…</div>
  if (!token) return <Navigate to="/login" replace />
  return children
}

function HomeRedirect() {
  const { token, loading } = useAuth()
  if (loading) return <div className="app-loading">Laden…</div>
  return token ? <Navigate to="/dashboard" replace /> : <Landing />
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/resend-verify-email" element={<ResendVerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/dashboard" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="upload" element={<Upload />} />
        <Route path="tracks/:id" element={<TrackDetail />} />
        <Route path="jobs" element={<JobQueue />} />
        <Route path="history" element={<History />} />
        <Route path="compare" element={<Compare />} />
        <Route path="buy-credits" element={<BuyCredits />} />
        <Route path="settings" element={<Settings />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="datenschutz" element={<Datenschutz />} />
        <Route path="agb" element={<AGB />} />
        <Route path="nutzungsbedingungen" element={<Nutzungsbedingungen />} />
        <Route path="anleitung" element={<Anleitung />} />
        <Route path="admin" element={<Admin />} />
      </Route>
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/nutzungsbedingungen" element={<Nutzungsbedingungen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
